<template>
  <div>
    <div class="controls">
      <v-btn

        @click="pickColor"
      >Pick {{ label }}
      </v-btn>
      <div
        class="selected-color-box"
        :style="selectedColorStyle"
      ></div>
    </div>

    <chrome-picker
      v-if="showPicker"
      :value="color"
      @input="onColorChange($event)"
      v-on-clickaway="hideColorPicker"
    />
  </div>
</template>

<script>
  import { Chrome as ChromeColorPicker } from 'vue-color'
  import { mixin as clickaway } from 'vue-clickaway';

  const defaultColor = { rgba: { r: '0', g: '0', b: '0', a: '1' }, background: '#000000' }

  export default {
    name: 'EColorPicker',
    components: {
      'chrome-picker': ChromeColorPicker
    },
    mixins: [ clickaway ],
    data () {
      return {
        showPicker: false,
        color: '#000000'
      }
    },
    props: {
      label: {
        type: String,
        default: 'Color'
      },
      value: {
        type: [String, Object],
        required: true,
        default: defaultColor
      }
    },
    watch: {
      value: {
        handler (newVal) {
          this.color = newVal
        },
        immediate: true
      }
    },
    computed: {
      selectedColorStyle () {
        const getChannel = c => this.color ? this.color.rgba[c] : ''
        return this.color.rgba
          ? {
            background: `rgba(
              ${getChannel('r')},
              ${getChannel('g')},
              ${getChannel('b')},
              ${getChannel('a')}
            )`
          }
          : {
            background: this.value.hex || '#000000'
          }
      }
    },
    methods: {
      pickColor () {
        this.showPicker = !this.showPicker
      },
      hideColorPicker () {
        this.showPicker = false
      },
      onColorChange (newColor) {
        this.color = newColor
        this.$emit('colorChange', newColor)
      },
      resetColor () {
        this.color = '#000000'
      }
    },
    created () {
      this.$bus.$on('resetColorPicker', this.resetColor)
    },
    beforeDestroy () {
      this.$bus.$off('resetColorPicker')
    }
  }
</script>

<style lang="scss" scoped>
  .btn {
    margin: 0;
  }

  .vc-chrome {
    margin-top: 10px;
  }

  .controls {
    display: flex;
    align-items: center;
    margin: 20px 0;
  }

  .selected-color-box {
    display: inline-block;
    width: 27px;
    height: 27px;
    margin-left: 10px;
    border-radius: 2px;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/EColorPicker/index.vue